import { LocaleText } from "../types/locale";
import { PickupAddr, PickupAddrFormData } from "../types/pickupAddr";
import { get, post } from "./fetch.core";

async function add(data: PickupAddrFormData) {
  const res = await post("/admin/pickupAddr/add", data);
  return res.data;
}

async function update(data: PickupAddrFormData & { id: string }) {
  await post("/admin/pickupAddr/update", data);
}

async function deleteRecord(id: string) {
  await post("/admin/pickupAddr/delete", { id });
}

async function getRecord(id: string) {
  const res = await get<PickupAddr>(`/admin/pickupAddr/get?id=${id}`);
  return res.data;
}

async function list() {
  const res = await get<PickupAddr[]>("/admin/pickupAddr/list");
  return res.data;
}

const pickupAddrCore = {
  getRecord,
  add,
  update,
  deleteRecord,
  list,
};

export default pickupAddrCore;
